/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { Image, Container, Row, Col } from "react-bootstrap";
import * as S from "./styles";

export interface IImageFeatureItem {
  icon: string | any;
  title: string;
  description?: string;
}

export interface IImageFeatureProps {
  imageFeatureSectionId?: string;
  imageFeatureTitle?: string;
  imageFeatureDescription?: string;
  imageFeatureImage?: string;
  imageFeatureFeatures?: IImageFeatureItem[];
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const ImageFeature = ({
  imageFeatureSectionId,
  imageFeatureTitle,
  imageFeatureDescription,
  imageFeatureImage,
  imageFeatureFeatures,
}: IImageFeatureProps) => {
  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === "string") {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={60}
            height={60}
            className="icon icon-md text-secondary"
          />
        );
      } else {
        const HeroIcon = require("@heroicons/react/solid");
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className="icon icon-md text-secondary"
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(
        <Icon key={`hero-icon-2`} className="icon icon-md text-secondary" />
      );
    }
    return _icon;
  };

  const _renderTitleSectionIf = () => {
    if (imageFeatureTitle) {
      return (
        <Col xs={12} className="text-center">
          <h2 className="px-lg-5">
            {imageFeatureTitle}
            {imageFeatureDescription && (
              <p className="lead px-lg-10">{imageFeatureDescription}</p>
            )}
          </h2>
        </Col>
      );
    }
  };

  const _renderImageIf = () => {
    if (imageFeatureImage) {
      return (
        <Col xs={12}>
          <Image
            src={imageFeatureImage}
            alt="image-feature-image"
            style={S.imageStyle}
          />
        </Col>
      );
    }
  };

  const _renderHeadingIf = () => {
    if (imageFeatureTitle) {
      return (
        <h5 className="fw-bolder text-center pt-1 pb-3">{imageFeatureTitle}</h5>
      );
    }
  };

  const _renderFeaturesIf = () => {
    return imageFeatureFeatures?.map((feature, index) => {
      if (feature?.icon) {
        return (
          <Col
            key={`image-feature-icon-${index}`}
            xs={6}
            md={4}
            className="text-center mb-4"
          >
            <div className="icon-shape bg-white shadow-lg border-light rounded-circle mb-4">
              {_getIcon(feature.icon)}
            </div>
            {feature?.title && <h3 className="fw-bolder">{feature.title}</h3>}
            {feature?.description && (
              <p className="text-gray">{feature?.description}</p>
            )}
          </Col>
        );
      }
    });
  };
  if (imageFeatureTitle) {
    return (
      <div className="section pt-0 bg-white" id={imageFeatureSectionId}>
        <Container className="mt-p10 mt-lg-p12 z-2">
          {/* <Row className="justify-content-center">
                    {_renderTitleSectionIf()}
                    {_renderImageIf()}
                </Row> */}
          <Row className="justify-content-center pt-5 pt-lg-6">
            {_renderHeadingIf()}
            {_renderFeaturesIf()}
          </Row>
        </Container>
      </div>
    );
  } else return null;
};

ImageFeature.defaultProps = {
  imageFeatureSectionId: "image-feature",
};
